import Vue from 'vue';
import Router from 'vue-router';
// import Home from '@/views/Home.vue';
// import Bets from '@/views/Bets.vue';
// import AppGol from '@/views/AppGol.vue';
// import Widget from '@/views/Widget.vue';

import { connectSocket /*, disconnectSocket*/ } from '@/utils/socketConnection';

Vue.use(Router);
const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/socialmedia',
      name: 'socialmedia',
      component: () => import('@/views/SocialMedia.vue'),
    },
    {
      path: '/test',
      name: 'test',
      component: () => import('@/views/speedo-meter/SpeedoMeterTest'),
    },
    {
      path: '/contact',
      name: 'contact',
      component: () => import('@/views/ContactMain.vue'),
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/Login.vue'),
    },
    {
      path: '/buy',
      name: 'buy',
      component: () => import('@/views/Buy.vue'),
    },
    {
      path: '/es/main',
      name: 'esMain',
      component: () => import('@/views/Login.vue'),
    },
    {
      path: '/profile-3pv',
      name: 'profile-3pv',
      component: () => import('@/views/Profile-3pv'),
      children: [
        {
          path: 'settings',
          name: 'settings',
          component: () => import('@/views/Profile-3pv/Settings/index'),
          children: [
            {
              path: 'payment',
              name: 'payment',
              component: () => import('@/views/Profile-3pv/Settings/PaymentMethods'),
            },
            {
              path: 'plans',
              name: 'plans',
              component: () => import('@/views/Profile-3pv/Settings/AvailablePlans'),
            },
          ],
        },
      ],
      meta: {
        title: 'Perfil',
      },
    },
    {
      path: '/',
      name: 'main',
      component: () => import('@/views/AppGol.vue'),
      children: [
        {
          path: 'about',
          name: 'about',
          component: () => import('@/views/About.vue'),
        },
        {
          path: 'tops',
          name: 'tops',
          component: () => import('@/views/SectionTops.vue'),
        },

        {
          path: '/terms',
          name: 'terms',
          component: () => import('@/views/Terms'),
          meta: {
            title: 'Términos y condiciones',
          },
        },
        {
          path: 'extended-calendar',
          name: 'extended-calendar',
          component: () => import('@/views/ExtendedCalendar.vue'),
        },
        {
          path: 'table',
          name: 'table',
          component: () => import('@/views/TableFull.vue'),
        },
        {
          path: 'golstats-data',
          name: 'golStatsData',
          component: () => import('@/views/GolStatsDataFull.vue'),
        },
        // {
        //   path: 'landing-out',
        //   name: 'landing',
        //   component: () => import('@/views/Landing.vue'),
        // },
        {
          path: 'landing',
          name: 'landing',
          component: () => import('@/views/Landing-V2.vue'),
        },
        {
          path: 'bets',
          name: 'bets',
          component: () => import('@/views/Landing-Bets.vue'),
        },
        {
          path: 'teamsAnalysis/teams',
          name: 'teams',
          component: () => import('@/views/Teams.vue'),
          meta: {
            to: 'team',
          },
        },
        {
          path: 'teamsAnalysis/:teamId',
          name: 'team',
          component: () => import('@/views/Team.vue'),
        },
        {
          path: 'playersAnalysis/teams',
          name: 'playerTeams',
          component: () => import('@/views/Teams.vue'),
          meta: {
            to: 'players',
          },
        },
        {
          path: 'playersAnalysis/teams/:teamId',
          name: 'players',
          component: () => import('@/views/Players.vue'),
        },
        {
          path: 'playersAnalysis/:seasonId/:playerId',
          name: 'player',
          component: () => import('@/views/Player.vue'),
        },
        {
          path: 'nextGamesAnalysis/games',
          name: 'games',
          component: () => import('@/views/Calendar.vue'),
          meta: {
            needSocket: false,
          },
        },
        {
          path: 'analyze',
          name: 'analyze',
          component: () => import('@/views/Analyze.vue'),
        },
        {
          path: 'nextGamesAnalysis/games/:gameId',
          name: 'nextGame',
          component: () => import('@/views/NextMatches.vue'),
          meta: {
            needSocket: true,
          },
        },
        {
          path: 'match/:gameId',
          name: 'matchAnalysis',
          component: () => import('@/views/MatchAnalysis'),
          meta: {
            needSocket: true,
            title: 'Partido',
            stayOnLogout: true,
          },
        },
        {
          path: '/internal-active-time',
          name: 'internalActiveTime',
          component: () => import('@/views/LandingActiveTime.vue'),
        },
        {
          path: '/activetime',
          name: 'activeTime',
          component: () => import('@/views/Landing-V2.vue'),
        },
        {
          path: '/headerfigma',
          name: 'headerfigma',
          component: () => import('@/views/HeaderFigma.vue'),
        },
      ],
    },
    {
      path: '/widget/:team',
      name: 'widget',
      component: () => import('@/views/AppGol.vue'),
    },
  ],
});

router.beforeEach((to, from, next) => {
  // Change Page Title (if meta title is present)
  // console.log('Change Page Title (if meta title is present)');
  // console.log(to);
  // console.log(from);

  const nearestWithTitle = to.matched
    .slice()
    .reverse()
    .find(r => r.meta && r.meta.title);
  document.title = nearestWithTitle ? nearestWithTitle.meta.title : 'GolStats';
  if (to.meta.needSocket) {
    connectSocket();
  } else {
    // disconnectSocket();
  }

  next();
});

export default router;
